import { ActionTypes } from "../constants";

export default function browse(state = {}, action) {
  switch(action.type) {
    case ActionTypes.SET_BROWSE_FUNDS_DATA:
      return Object.assign({}, state, action.payload);

    case ActionTypes.SET_BROWSE_CURRENT_FILTERS:
      return Object.assign({}, state, action.payload);

    case ActionTypes.SET_BROWSE_SORT_OPTION:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
}